
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';

// utilities
// import cx from 'classnames';
import { filter, isNil } from 'lodash';

// components
import ProgressComponentList from '../../../../../../common/components/C_ProgressComponentList';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import EducationRecord from './EducationRecord';

// static constants
const formHeading = 'Education';
const formText = `
  Please provide your educational information above high school.
`;

// styling obj
const addButtonStyle = {
  display: 'inline-block',
  top: '35px',
  width: '165px',
  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
};


export default class Education extends ProgressComponentList {
  static propTypes = {
    education: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired
  }

  today = new Date();

  // Override ValidatedForm.validateForm()
  validateForm() {
    return filter(this.refs, ref => ref.validateForm)
      .reduce((valid, section, index) => section.validateForm() && valid, true);
  }

  handleRemove = (clientId) =>
    () => this.removeListItem(clientId);

  render() {
    const educationArr = this.getList(false, ['employmentEnd', 'employmentStart'], ['desc', 'desc']);

    return (
      <div className='education-container application-section-container clearfix'>
        <div className='form-heading'>
          {formHeading}
        </div>
        <div className='form-text'>
          {this.props.submitted ? '': formText}
        </div>
        {
          educationArr.map((education, index, arr) =>
            <EducationRecord
              index={index}
              ref={education.clientId}
              key={education.clientId}
              staticData={this.props.staticData}
              education={education}
              tempState={this.props.tempState}
              validation={this.props.validation}
              onChange={this.onChange.bind(this)}
              onRemove={this.handleRemove(education.clientId)}
            />
          )
        }
        <FlatButton
          onClick={this.addListItem}
          style={{...addButtonStyle, ...(!educationArr.length && {top: '10.5px'} || {})}}
          label='Add Education'
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Background/c_Education/index.js